export default {
    urls: {
        app: "https://storytime-staging.firebaseapp.com",
        marketing: "https://storytime-marketing-staging.firebaseapp.com",
    },
    auth: {
        signInOptions: [
            {
                clientId: "483366416271-ihb9qiql7snkbgb3q64l26apkqle3pjq.apps.googleusercontent.com",
            },
        ],
        tosUrl: "https://storytime-marketing-staging.firebaseapp.com/tos",
        privacyPolicyUrl: "https://storytime-marketing-staging.firebaseapp.com/privacy",
    },
    firebase: {
        apiKey: "AIzaSyB8MClNsLeu_Yxu0g7c7DQOjTk9g7fBBdE",
        authDomain: "storytime-staging.firebaseapp.com",
        databaseURL: "https://storytime-staging.firebaseio.com",
        projectId: "storytime-staging",
        storageBucket: "storytime-staging.appspot.com",
        messagingSenderId: "483366416271",
        appId: "1:498216966416:web:24de41a6cad4c26275ed95",
        measurementId: "G-LQYZVZNZBX",
    },
};
//# sourceMappingURL=staging.js.map